import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {TeamForAdmin, TeamMemberForAdmin} from '../team';

@Injectable()
export class AdminSearchService {

    constructor(private http: HttpClient) { }

    async do_admin_search(query: string): Promise<{teams: TeamForAdmin[], members: TeamMemberForAdmin[]}> {
        return await firstValueFrom(this.http.get<{teams: TeamForAdmin[], members: TeamMemberForAdmin[]}>(`/admin/search`, {
            params: {query: query}
        }))
    }

    async getFeaturesToggles(): Promise<FeatureToggle[]> {
        return await firstValueFrom(this.http.get<FeatureToggle[]>(`/admin/featuretoggles/`));
    }
}

export interface FeatureToggle {
    feature: string
}